import { create } from "zustand";

type UserData = {
  id?: number;
  name?: string;
  phone?: string;
  role?: "admin" | "master" | "senior_master" | "accountant";
  hourly_rate?: number;
  place_of_birth?: string;
  email?: string;
  is_self_employed?: boolean;
  comment?: string;
  citizenship_id?: number;
  status?: "active" | "unactive";
};

export type UserStoreState = {
  user: {
    isAuthorized: boolean;
    isAuthorizationChecked: boolean;
    userData: UserData;
  };
  setUser: (
    update: (state: {
      isAuthorized: boolean;
      isAuthorizationChecked: boolean;
      userData: UserData;
    }) => {
      isAuthorized: boolean;
      isAuthorizationChecked: boolean;
      userData: UserData;
    }
  ) => void;
};

const useUserStore = create<UserStoreState>((set) => ({
  user: { isAuthorized: false, isAuthorizationChecked: false, userData: {} },
  setUser: (update) =>
    set((state) => ({
      user: update(state.user),
    })),
}));

export default useUserStore;
